import { useState, useEffect, useRef, Fragment } from "react";
import Slider from '@mui/material/Slider';
import { formatCurrency, formatNumber, formatPercent, stringToNumber } from "../helpers/utils"

const ConstantSumQuestion = ({ question, statements, responses, saveResponses, compact }) => {

    // console.log(question);

    const [sliders, setSliders] = useState([]);
    const [total, setTotal] = useState(0);

    const [textInputs, setTextInputs] = useState([]);


    const fullyAllocated = useRef(false);
    const sliderQueue = useRef([]);
    const textInputQueue = useRef([]);

    // const userSetValues = useRef({});

    const questionId = useRef(null);

    const onTextInputChange = (n, constantSumStatementId) => {

        // first, strip all characters other than 0-9 and .
        n = n.replace(/[^0-9.]/g, "");

        // cache this special case, if the last character of the user's input is the decimal point

        const specialCase = (n.at(-1) === ".");

        // Split n on "." into an array.
        // There should be either 1 or 2 items in the array, but there might be more
        // if the user has entered more than one decimal point.
        // The first item is the whole number; the remaining items are combined to become the decimal part.

        const parts = n.split(".");

        const whole = parts.shift();
        const decimal = parts.join("");

        let formatted;

        if ((decimal === "") && specialCase) {
            formatted = formatNumber(whole) + ".";
        } else if (decimal === "") {
            formatted = formatNumber(whole);
        } else {
            formatted = formatNumber(whole) + "." + decimal;
        }

        const newTextInputs = [...textInputs];
        for (let textInput of newTextInputs) {
            if (textInput.constantSumStatementId === constantSumStatementId) {
                // textInput.value = stringToNumber(formatted);
                textInput.formattedValue = formatted;
                break;
            }
        }
        setTextInputs(newTextInputs);
    }
    const onTextInputBlur = (newValue, constantSumStatementId) => {

        const newTextInputs = [...textInputs];

        // validate the input

        let changed = false;

        for (let textInput of newTextInputs) {
            if (textInput.constantSumStatementId === constantSumStatementId) {
                let value = stringToNumber(textInput.formattedValue);
                if (isNaN(value)) {
                    value = 0;
                } else {
                    value = Math.min(value, question.statementMaximum);
                }
                if (textInput.value !== value) {
                    changed = true;
                    textInput.value = value;
                    textInput.formattedValue = formatNumber(value);
                }
                break;
            }
        }

        if (changed) {

            // move the current input to the end of the textInputQueue; this is the last input we'll adjust next time
            const index = textInputQueue.current.indexOf(constantSumStatementId);
            textInputQueue.current.splice(index, 1);
            textInputQueue.current.push(constantSumStatementId);
            console.log(textInputQueue.current);

            let total = 0;

            for (let textInput of newTextInputs) {
                total += textInput.value;
            }
            if (total >= question.total) {
                fullyAllocated.current = true;
            }

            // if/once the user has reached full allocation, we can adjust the other inputs to maintain full allocation
            if (fullyAllocated.current && (total !== question.total) && question.constantSum) {

                let
                    index,
                    adjustingConstantSumStatementId,
                    textInput,
                    delta,
                    newTextInputValue;

                index = 0;

                while ((total !== question.total) && (index < (newTextInputs.length - 1))) {

                    delta = question.total - total;

                    // get the next id from the textInputQueue
                    adjustingConstantSumStatementId = textInputQueue.current[index];

                    // get the associated textInput
                    for (textInput of newTextInputs) {
                        if (textInput.constantSumStatementId === adjustingConstantSumStatementId) {
                            break;
                        }
                    }

                    newTextInputValue = Math.max(0, Math.min(question.statementMaximum, textInput.value + delta));

                    total = total - textInput.value + newTextInputValue;

                    textInput.value = newTextInputValue;
                    textInput.formattedValue = formatNumber(newTextInputValue);

                    index++;

                }

            }

            setTotal(total);
            setTextInputs(newTextInputs);

            let params = {
                surveyQuestionId: question.surveyQuestionId,
                constantSumResponses: []
            };
            for (let textInput of newTextInputs) {
                params.constantSumResponses.push({
                    surveyQuestionId: question.surveyQuestionId,
                    constantSumStatementId: textInput.constantSumStatementId,
                    response: textInput.value
                })
            }
            saveResponses(params);

        }

    }

    const onSliderChanged = (newValue, constantSumStatementId) => {

        const newSliders = [...sliders];
        let total = 0;
        for (let slider of newSliders) {
            if (slider.constantSumStatementId === constantSumStatementId) {
                slider.value = newValue;
            }
            total += slider.value;
        }
        if (total >= question.total) {
            fullyAllocated.current = true;
        }
        // once the user has reached full allocation, we can adjust the other slider bars to maintain full allocation
        if (fullyAllocated.current && (total !== question.total)) {

            let
                index,
                adjustingConstantSumStatementId,
                slider,
                delta,
                newSliderValue;

            index = 0;
            while ((total !== question.total) && (index < sliders.length)) {

                delta = question.total - total;

                // get the next id from the sliderQueue
                adjustingConstantSumStatementId = sliderQueue.current[index];

                // don't adjust the current slider
                if (adjustingConstantSumStatementId !== constantSumStatementId) {
                    // get the associated slider bar
                    for (slider of sliders) {
                        if (slider.constantSumStatementId === adjustingConstantSumStatementId) {
                            break;
                        }
                    }

                    newSliderValue = Math.max(0, Math.min(question.statementMaximum, slider.value + delta));

                    total = total - slider.value + newSliderValue;

                    slider.value = newSliderValue;

                }

                index++;

            }
        }
        setTotal(total);
        setSliders(newSliders);
    }
    /*
    const onSliderChanged = (newValue, constantSumStatementId) => {

        const newSliders = [...sliders];
        let total = 0;
        for (let slider of newSliders) {
            if (slider.constantSumStatementId === constantSumStatementId) {
                slider.value = newValue;
            }
            total += slider.value;
        }
        if (total >= question.total) {
            fullyAllocated.current = true;
        }

        userSetValues.current[constantSumStatementId] = newValue;

        // once the user has reached full allocation, we can adjust the other slider bars to maintain full allocation
        if (fullyAllocated.current && (total !== question.total)) {

            total = 0;
            for (let slider of newSliders) {
                slider.value = userSetValues.current[slider.constantSumStatementId]
                total += slider.value;
            }

            let
                index,
                adjustingConstantSumStatementId,
                slider,
                delta,
                newSliderValue;

            index = 0;
            while ((total !== question.total) && (index < sliders.length)) {

                delta = question.total - total;

                // get the next id from the sliderQueue
                adjustingConstantSumStatementId = sliderQueue.current[index];

                // don't adjust the current slider
                if (adjustingConstantSumStatementId !== constantSumStatementId) {
                    // get the associated slider bar
                    for (slider of sliders) {
                        if (slider.constantSumStatementId === adjustingConstantSumStatementId) {
                            break;
                        }
                    }

                    newSliderValue = Math.max(0, Math.min(question.statementMaximum, slider.value + delta));

                    total = total - slider.value + newSliderValue;

                    slider.value = newSliderValue;

                }

                index++;

            }
        }
        setTotal(total);
        setSliders(newSliders);
    }
    */
    const onSliderReleased = (newValue, constantSumStatementId) => {

        // move the current slider bar to the end of the sliderQueue; this is the last slider bar we'll adjust next time
        const index = sliderQueue.current.indexOf(constantSumStatementId);
        sliderQueue.current.splice(index, 1);
        sliderQueue.current.push(constantSumStatementId);

        let params = {
            surveyQuestionId: question.surveyQuestionId,
            constantSumResponses: []
        };
        for (let slider of sliders) {
            params.constantSumResponses.push({
                surveyQuestionId: question.surveyQuestionId,
                constantSumStatementId: slider.constantSumStatementId,
                response: slider.value
            })
        }
        // console.log(sliders);
        saveResponses(params);
    }

    const applyFormat = (n) => {
        switch (question.numberType) {
            case "percent":
                return formatPercent(n);
            case "currency":
                return formatCurrency(n);
            default:
                return formatNumber(n);
        }
    }

    useEffect(() => {

        const newSliders = [];
        const newTextInputs = [];

        if (question.useSliders) {
            for (let statement of statements) {
                newSliders.push({
                    label: statement.text,
                    constantSumStatementId: statement.constantSumStatementId,
                    displayOrder: statement.displayOrder,
                    value: 0
                });
            }
            for (let response of responses) {
                for (let slider of newSliders) {
                    if (slider.constantSumStatementId === response.constantSumStatementId) {
                        slider.value = response.response;
                        break;
                    }
                }
            }
            newSliders.sort((a, b) => {
                return a.displayOrder - b.displayOrder;
            });
        } else {
            for (let statement of statements) {
                newTextInputs.push({
                    label: statement.text,
                    constantSumStatementId: statement.constantSumStatementId,
                    displayOrder: statement.displayOrder,
                    formattedValue: "",
                    value: 0
                });
            }
            for (let response of responses) {
                for (let textInput of newTextInputs) {
                    if (textInput.constantSumStatementId === response.constantSumStatementId) {
                        textInput.value = response.response;
                        textInput.formattedValue = formatNumber(response.response);
                        break;
                    }
                }
            }
            newTextInputs.sort((a, b) => {
                return a.displayOrder - b.displayOrder;
            });
        }

        let total = 0;
        for (let response of responses) {
            total += response.response;
        }
        fullyAllocated.current = (total >= question.total);
        setTotal(total);

        if (questionId.current !== question.questionId) {

            // rebuild queues

            questionId.current = question.questionId;

            if (question.useSliders) {
                sliderQueue.current = [];
                for (let slider of newSliders) {
                    sliderQueue.current.push(slider.constantSumStatementId);
                }
            } else {
                textInputQueue.current = [];
                for (let textInput of newTextInputs) {
                    textInputQueue.current.push(textInput.constantSumStatementId);
                }
            }
        }

        if (question.useSliders) {
            setSliders(newSliders);
        } else {
            setTextInputs(newTextInputs);
        }

    }, [question, statements, responses]) // eslint-disable-line react-hooks/exhaustive-deps

    const maxLength = (formatNumber(question.statementMaximum)).length + 1;

    return (
        <div className={`${compact ? "compact" : ""} constant-sum-question-container`}>
            {
                (sliders.length > 0) ?
                    <>
                        {
                            sliders.map((slider, i) => {
                                return (
                                    <div key={slider.constantSumStatementId} className="label-and-slider">
                                        <div className="toolbar">
                                            <label>{slider.label}</label>
                                            <label>{applyFormat(slider.value)}</label>
                                        </div>
                                        <Slider
                                            value={slider.value}
                                            min={0}
                                            max={question.statementMaximum}
                                            step={1}
                                            onChange={(e, newValue) => onSliderChanged(newValue, slider.constantSumStatementId)}
                                            onChangeCommitted={(e, newValue) => onSliderReleased(newValue, slider.constantSumStatementId)}
                                            valueLabelDisplay="auto"
                                            valueLabelFormat={(value) => `${applyFormat(value)}`}
                                        />
                                    </div>
                                )
                            })
                        }
                        <div className="toolbar">
                            <label>Total:</label>
                            <label>{applyFormat(total)}</label>
                        </div>
                    </>
                    :
                    null
            }
            {
                (textInputs.length > 0) ?
                    <div className={`text-inputs-grid ${compact ? "compact" : ""}`}>
                        {
                            textInputs.map((textInput, i) => {
                                return (
                                    <Fragment key={textInput.constantSumStatementId}>
                                        {/* <label key={i}>{textInput.label} {textInput.label} {textInput.label} {textInput.label} {textInput.label} {textInput.label} {textInput.label}</label> */}
                                        <label key={i}>{textInput.label}</label>
                                        <input key={`input${textInput.constantSumStatementId}`} className={`numeric ${compact ? "compact" : ""} ${question.numberType}`} type="text" id={textInput.constantSumStatementId} name={textInput.constantSumStatementId} placeholder="0" maxLength={maxLength} size={maxLength} autoComplete="off" value={textInput.formattedValue} onChange={(e) => onTextInputChange(e.target.value, textInput.constantSumStatementId)} onFocus={(e) => e.target.select()} onBlur={(e) => onTextInputBlur(e.target.value, textInput.constantSumStatementId)} />
                                    </Fragment>
                                )
                            })
                        }
                        <label>Total</label>
                        <input className={`numeric ${compact ? "compact" : ""} ${question.numberType}`} type="text"  maxLength={maxLength} size={maxLength} autoComplete="off" value={formatNumber(total)} readOnly={true} tabIndex={-1}/>
                    </div>
                    :
                    null
            }
        </div>
    );

};

export default ConstantSumQuestion;